import { loginService } from '@agro1desenvolvimento/apis-js-package';

import { APP_ENVIRONMENT, APP_SYSTEM, USE_MOCK_API } from './env';

export class UnauthenticatedError extends Error {
  constructor() {
    super('Usuário não autenticado.');
    this.name = 'UnauthenticatedError';
  }
}

export async function initializeAuth(): Promise<void> {
  await loginService.initializeByEnvironment(APP_SYSTEM, APP_ENVIRONMENT);

  if (!loginService.isLoggedIn) {
    loginService.redirectInvalidUser();
    throw new UnauthenticatedError();
  }
}

export function getAuthHeaders(): Record<string, string> {
  if (USE_MOCK_API) return {};

  const { Authorization } = loginService.requestHeaders();

  return Authorization ? { Authorization } : {};
}

export type CurrentUser = {
  name: string;
  initials: string;
};

const MOCK_USER: CurrentUser = { name: 'User Teste', initials: 'UT' };

function toInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts.at(0)?.charAt(0) ?? '';
  const last = parts.length > 1 ? (parts.at(-1)?.charAt(0) ?? '') : '';

  return `${first}${last}`.toUpperCase();
}

export function getCurrentUser(): CurrentUser | null {
  if (USE_MOCK_API) return MOCK_USER;

  const user = loginService.currentUser;
  if (!user) return null;

  return { name: user.name, initials: toInitials(user.name) };
}

export function getScope(): string {
  return loginService.scope ?? '';
}

export function getToken(): string | null {
  return loginService.token;
}

export function isLoggedIn(): boolean {
  return loginService.isLoggedIn;
}

export function logout(): Promise<void> {
  return loginService.logout();
}

export function redirectInvalidUser(): void {
  loginService.redirectInvalidUser();
}

export function redirectToScopeSelection(): void {
  loginService.redirectToScopeSelection();
}

export function subscribeToCurrentUser(listener: () => void): () => void {
  loginService.addOnUserChange(listener);

  return () => loginService.removeOnUserChange(listener);
}
